import { ReactComponent as FileUploadIcon } from '@/assets/img/v2/add-pink-icon.svg';
import './PetProfileCard.scss';
import { Pet } from '../types';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

type PetProfileCardProps = {
  onClick: () => void;
};
export const AddNewPetCard = ({ onClick }: PetProfileCardProps) => {
  const { t, i18n } = useTranslation();
  return (
    <div className="add-pet-card" onClick={() => onClick()}>
      <div className="pic-container">
        <FileUploadIcon />
      </div>
      <p className="name">{t('+ Add Pet')}</p>
    </div>
  );
};
